var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.component &&
      !_vm.preview && _vm.renderTools &&
      ![
        'reheight_widget',
        'remargin_widget',
        'crop_image',
        'sort_widget' ].includes(_vm.mode) &&
      _vm.parentWidgetActive.id
    ),expression:"\n      component &&\n      !preview && renderTools &&\n      ![\n        'reheight_widget',\n        'remargin_widget',\n        'crop_image',\n        'sort_widget',\n      ].includes(mode) &&\n      parentWidgetActive.id\n    "}],attrs:{"position":_vm.parentWidgetActive.position,"parentWidget":true,"id":"parent-widget-active"}},[_c('WidgetHover',{class:_vm.getParentClass(),style:(_vm.positionParent),on:{"click":function($event){return _vm.goToWidgetParent()}}},[_vm._v(" "+_vm._s(_vm.widgetTypeShow)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }